/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { Header, ActionButton, Flex, View } from '@adobe/react-spectrum';
import BackAndroid from '@spectrum-icons/workflow/BackAndroid';

import classes from './PropertiesHeader.scss';

const messages = defineMessages({
    labelGoBack: {
        id: 'label.goBack',
        defaultMessage: 'Go Back'
    }
});

/**
 * Displays a header bar used by properties pages with a back button and title.
 */
const PropertiesHeader = props => {
    const { onGoBack, title, subtitle } = props;
    const { formatMessage } = useIntl();

    return (
        <View height="100%" paddingX="size-400" borderColor="default" borderBottomWidth="thin">
            <Flex direction="row" height="100%" justifyContent="space-between">
                <View height="100%">
                    <Flex gap="size-175" height="100%" alignItems="center">
                        <ActionButton isQuiet aria-label={formatMessage(messages.labelGoBack)} onPress={onGoBack}>
                            <BackAndroid />
                        </ActionButton>
                        <Header>
                            <div className={classes.title}>{title}</div>
                            <div className={classes.subtitle}>{subtitle}</div>
                        </Header>
                    </Flex>
                </View>
                <View>
                    <Flex gap="size-175">
                        {/* UX Placeholder
                <ButtonGroup>
                    <Button variant="primary">Download</Button>
                    <Button variant="cta">Share</Button>
                </ButtonGroup> */}
                    </Flex>
                </View>
            </Flex>
        </View>
    );
};

PropertiesHeader.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onGoBack: PropTypes.func
};

export default PropertiesHeader;
